<template>
    <div class="credentials-details-with-async-fallback">
      <back-navigation-header :on-back="backButtonClicked" :disabled="isLoading" :show-back="!asyncTimeoutReached"/>
      <async-fallback v-if="asyncTimeoutReached" :source="source"/>
      <slot v-else name="credentials"/>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import AsyncFallback from '@/base-components/onboarding/AsyncFallback';
import ModalBus from '@/event-bus/modal-bus';
import BackNavigationHeader from '@/base-components/app-header/BackNavigationHeader';
import LoadingPopupWithAsyncFallback
  from '@/pages/responsive-pages/authenticated/onboard2/LoadingPopupWithAsyncFallback';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';

export default {
  name: 'CredentialsDetailsWithAsyncFallback',
  components: {
    AsyncFallback,
    BackNavigationHeader,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  async created() {
    if (this.isLoading && !this.asyncTimeoutReached) {
      this.openLoadingPopup();
    }
    Segment.trackUserGot('CreateCredentialsEntered', { sourceType: this.source.type, sourceName: this.source.sourceName });
  },
  beforeDestroy() {
    this.closeModal();
  },
  computed: {
    ...mapState('onboardingState', ['isLoading', 'nameAlreadyUsedError', 'loadingStartTime', 'saveCredentialsError', 'asyncTimeoutReached']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    ...mapGetters('sourceFields', ['getSourceBySourceName']),
    source() {
      return this.getSourceBySourceName(this.sourceName);
    },
  },
  methods: {
    ...mapActions('onboardingState', ['saveCredentials']),
    ...mapMutations('onboardingState', ['setNameAlreadyInUseError']),
    async saveCredsAndStartLoading({ sourceName, credentials, name, sourceType }) {
      await this.saveCredentials({ sourceName, credentials, name, sourceType });
    },
    openLoadingPopup(loadingStartTime) {
      ModalBus.$emit('open', {
        component: LoadingPopupWithAsyncFallback,
        popupAlignment: 'center',
      });
    },
    closeModal() {
      ModalBus.$emit('close-modal');
    },
    backButtonClicked() {
      Segment.trackUserInteraction('BackButtonClicked', { sourceType: this.source.type, sourceName: this.source.sourceName });
      this.handleBack();
    },
  },
  watch: {
    isLoading(newValue, oldValue) {
      DDLogs.log('isLoading', { oldValue, newValue });
      if (newValue) {
        this.openLoadingPopup();
      } else if (oldValue && !newValue) {
        this.closeModal();
      }
    },
    asyncTimeoutReached(newValue, oldValue) {
      if (newValue) {
        this.closeModal();
      }
    },
    saveCredentialsError(newValue, oldValue) {
      if (newValue) {
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
